<template>
    <div>
        <div class="work_r_navlist" v-show="this.seletype == false">
            <!--  -->
            <!-- //任务筛选 -->
            <div class="coursenav clearfix" style="display:none;">
                <div>班级：</div>
                <div 
                    v-for="(item,index) in this.subjectlist" :key="index" 
                    @click="selectsubj(item,index)" 
                    :class="{subjactive: itemind == index}">{{item.name}}</div>
            </div>
            <div class=" coursenav2 coursenav clearfix">
                <div>类型：</div>
                <div v-for="(item,index) in this.subjtype" :key="index" 
                    @click="selecttype(item,index)"
                    :class="{subjactive: iteminx == index}"
                >{{item.typename}}</div>
            </div>
            
        </div>
        <div class="work_r_navlist work_r_navlist2" v-show="this.seletype == true">
            <!-- //错题集 -->
            <div class="coursenav2  coursenav coursenav3 clearfix" >
                <div>时间: </div>
                <div>今日</div>
                <div>本周</div>
                <div>本月</div>
                <div>本学期</div>
                <div>自定义</div> 
            </div>
            <div class="coursenav2  coursenav coursenav3 clearfix">
                <div>错题率: </div>
                <div>30~50%</div>
                <div>50%~60%</div>
                <div>70%~80%</div>
                <div>80%~90%</div>
                <div>90%以上</div> 
            </div>
            <div class="coursenav2 coursenav  clearfix">
                <div>题型: </div>
                <div>选择</div>
                <div>填空</div>
                <div>选择</div>
            </div>
        </div>

        <!-- 未批阅 任务 -->
        <div class="work_r_readlist" v-show="this.datasize == true">
            <div class="clearfix" >
                <div @click="fabu" class="issueworkbtn">
                    <div></div>
                    <div>发布作业</div>
                </div>
            </div>
        </div>
        <div v-show="this.datasize == false">
            <div class="work_r_readlist" v-show="this.seletype == false" v-loading="loading">
                <div @click="fabu" class="issueworkbtn">
                    <div></div>
                    <div>发布作业</div>
                </div>
                <div class="clearfix"  v-for="(item,index) in this.workregroup.slice((currentPage-1)*pagesize,currentPage*pagesize)" :key="index">
                    <div class="datatitle">
                        <span></span>
                        <p>{{item.create_time.substring(5,16)}}</p>
                    </div>
                    
                    <div class="worklist clearfix">
                        <div class="workdialog" @click="detailspath(item)">
                            <div>
                                <div class="dialogtop clearfix bankwork">
                                    <!-- <span>数学：题库作业</span> -->
                                    <span v-show="item.storage == 2">自定义作业</span>
                                    <span v-show="item.storage == 1">题库作业</span>
                                    <p :title="item.title">{{item.title}}</p>
                                    <!-- <span class="weipiyue">未批阅(1)</span> -->
                                    <!-- <span class="yijiezhi">已截止</span> -->
                                    <!-- <span class="daifabu">待发布</span> -->
                                    <span class="bujiao">补交</span>
                                </div>
                                <el-row :gutter="10" class="dialogmain">
                                    <el-col :span="8">已提交：<span>{{item.did_num}}</span>/{{item.student_num}}</el-col>
                                    <!-- <el-col :span="8">人均耗时：<span>15分钟</span></el-col>
                                    <el-col :span="8">正确率：<span>85%</span></el-col> -->
                                </el-row>
                                <el-row :gutter="10" class="dialogbottom">
                                    <el-col :span="12">发布：{{item.create_time}}</el-col>
                                    <el-col :span="12">截止：{{item.end_time}}</el-col>
                                </el-row>
                            </div>
                        </div>

                    </div>
                </div>

                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="this.workregroup.length">
                </el-pagination>
            </div>
        </div>
        <!-- 错题集 -->
        <div class=" work_r_errorlist" v-show="this.seletype == true">
            <el-row class="errortitle" >
                <el-col :span="2"><span>应用</span></el-col>
                <el-col :span="22">这是一个错题标题</el-col>
            </el-row>
            <el-row class="errormain">
                <el-col :span="12">错题率65%</el-col>
                <el-col :span="12">发布时间： 2020-7-12</el-col>
            </el-row>
            <div class="errorquestion">

            </div>
        </div>

        <!-- <div @click="fabu">发布作业</div> -->

    </div>
</template>
<script>
import eventBus from "@/api/eventBus";
import URL from '@/api/index'
export default {
    data(){
        return{
            seletype: false,
            subjectlist:[],
            itemind: 0,
            iteminx: 0,
            subjtype: [
                {typename:'全部',typeid: '0'},
                {typename:'题库作业',typeid: '1'},
                {typename:'自定义作业',typeid: '2'},
            ],
            classid: 0,
            questionlist:[],   
            textArr:[            
                {value:'一'}, {value:'二'}, {value:'三'}, {value:'四'}, {value:'五'}, {value:'六'}, {value:'七'}, {value:'八'}, {value:'九'}
            ],
            workregroup:[],
            questiontype: 0,
            currentPage: 1,
            pagesize: 10,
            page:1,
            loading:true,
            datasize: true,
        }
    },
    created(){
        
        
        //左侧选项传参   
        // 时间 错题 题型： 错题集
        // 科目 类型：未批阅 任务 
        eventBus.$on('treedata', ( val ) => {
            if( val == 2 ){
                this.seletype = false
            }else if( val == "错题集" ){
                this.seletype = true
            }else if(  val == "任务" ){
                this.seletype = false
            }
        }),
        //科目列表
        eventBus.$on('subdata',( val ) => {
            // this.subjectlist = val
            // this.subjectlist = []   
            // this.subjectlist = this.subjectlist.concat({ sid: 0, subject_name: "全部"}).concat(val)
            // this.filtratea3 = this.filtratea3.concat({ type_id: 0, type_name: "全部题型"}).concat(this.getquesttype)
        })
        //教室选择班级
        eventBus.$on('gid',( val ) => {
            // console.log(val.gid)
            this.classid = val.gid
            this.workregroup = []
            this.getclass()
        })
    },
    mounted(){
        this.loading = true
        this.Token = JSON.parse(localStorage.getItem('loginInfo')).token
        this.classid = JSON.parse(localStorage.getItem('loginInfo')).class_id
        this.getclass()
        this.getclasslist()
    },
    methods:{
        handleSizeChange(val) {
            this.pagesize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        //获取老师所在班级
        getclasslist(){
            this.$post(URL.classlist,      
                {
                    "token": this.Token,
                }
            )
            .then( getclasslist => {
                // console.log(getclasslist)
                var classnamelist  = getclasslist.result
                var i = 0;
                if(getclasslist.result==null ){
                    this.subjectlist.push({
                        name: "暂无班级"
                    })
                }else{
                    for( i ; i < classnamelist.length ; i++){
                        var name = classnamelist[i].class_name //班级
                        var grade_name = classnamelist[i].grade_name
                        var classname = grade_name + name
                        var classid = classnamelist[i].class_id
                        // console.log(classid)
                        this.subjectlist.push({
                            name: classname,
                            class_id: classid,
                        })
                        this.clid = classid              
                    }
                    this.subjectlist.splice(0,0,{name: "全部",class_id: 0,})
                    // console.log(this.actionb)     
                    this.unique(this.subjectlist)    
                    // console.log(this.subjectlist)               
                }     
            })
        },

        //去重
        unique(arr) {
            for (var i = 0, len = arr.length; i < len; i++) {
                for (var j = i + 1, len = arr.length; j < len; j++) {
                    // console.log(arr[i],arr[j])
                    if (arr[i].class_id === arr[j].class_id) {
                        arr.splice(j, 1);
                        j--;
                        len--;
                    }
                }
            }
            return arr;
        },



        //获取试题列表
        getclass(){
            var calssdata = {
                token: this.Token,
                // class_id: this.classid,
                type: this.questiontype,
                storage: this.questiontype,
            }
            this.$post(URL.getclass,calssdata).then( getwork =>{
                // console.log(getwork.msg)
                if( getwork.msg == '暂无数据' ){
                    this.datasize = true
                }else{
                    this.datasize = false
                    this.workregroup = []
                    this.questionlist = getwork.result.lists
                    this.getworklist = getwork.result.lists
                    this.tasklist = getwork.result.lists
                    var i = 0;
                    var tasklistleng = this.tasklist.length
                    // console.log(this.workregroup,'初始化后',this.workregroup.length)
                    for( i ; i < tasklistleng ; i++ ){
                        var createtime = this.tasklist[i].create_time//时间
                        var endtime = this.tasklist[i].end_time//结束时间
                        var title = this.tasklist[i].title//题目
                        var classname = this.tasklist[i].class_info.class_name//班 
                        var gradeid =  this.textArr[this.tasklist[i].class_info.grade_id - 1].value//年级
                        var storage = this.tasklist[i].storage//状态
                        var didnum = this.tasklist[i].did_num//提交人数
                        var studentnum = this.tasklist[i].student_num//总人数
                        var nocorrectnum = this.tasklist[i].nocorrect_num//未批阅
                        var assignid = this.tasklist[i].assign_id 
                        var examid = this.tasklist[i].exam_id//试卷ID
                        this.workregroup.push({
                            create_time: createtime,
                            end_time: endtime,
                            storage: storage,
                            title: title,
                            did_num: didnum,
                            student_num: studentnum,
                            nocorrect_num: nocorrectnum,
                            grade_id: gradeid,
                            class_name: classname,
                            assign_id: assignid,
                            exam_id: examid
                        })
                        this.loading = false
                    }
                }
                // console.log(this.workregroup.length,'塞入数据')
                
            })
        },
        //选择科目
        selectsubj(val,index){
            this.itemind = index
        },
        //选择类型
        selecttype(val,index){
            // console.log(val)
            this.loading = true
            this.iteminx = index
            this.questiontype = val.typeid
            this.workregroup = []
            this.getclass()
        },



        fabu(){
            // eventBus.$emit("fabu","click")  
            this.$router.push({
                name:'issuework',
            })
        },
        //作业详情
        detailspath(val){
            // console.log(val)
            if( val.storage == 1 ){
                this.$router.push({
                    name:'workcheck',
                    query:{
                        assid: val.assign_id,
                        examid: val.exam_id
                    }
                }) 
            }else{
                this.$router.push({
                    name:'customwork',
                    query:{
                        assid: val.assign_id,
                        examid: val.exam_id
                    }
                })  
            }
            
        },

        
    }

}
</script>
<style scoped>

 body, html, div, blockquote, img, label, p, h1, h2, h3, h4, h5, h6, pre, ul, ol,
li, dl, dt, dd, form, a, fieldset, input, th, td, i, em{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
}


</style>